import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tbody', 'spinner', 'status']
  static values = { url: String }

  connect() {
    this.renderSpinner(true)
    this.load()
  }

  load() {
    if (!this.urlValue) return

    fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((payload) => this.render(payload.lessons))
      .catch(() => this.renderSpinner(false))
  }

  render(lessons) {
    if (!Array.isArray(lessons) || lessons.length === 0) {
      this.tbodyTarget.innerHTML = ''
      this.renderSpinner(false, 'No lessons found')
      return
    }

    const rows = lessons
      .map(
        (lesson) => `
        <tr class="mdc-data-table__row" data-row-id="${lesson.id}">
          <td class="mdc-data-table__cell mdc-data-table__cell--numeric">${lesson.id}</td>
          <td class="mdc-data-table__cell">
            <a class="no-hover" href="${lesson.href}">${lesson.name || ''}</a>
          </td>
          <td class="mdc-data-table__cell">${lesson.lesson_type}</td>
          <td class="mdc-data-table__cell">${lesson.category}</td>
          <td class="mdc-data-table__cell">${lesson.band_label} / ${lesson.level}</td>
          <td class="mdc-data-table__cell">${lesson.team_name}</td>
        </tr>`
      )
      .join('')

    this.tbodyTarget.innerHTML = rows
    this.renderSpinner(false)
  }

  renderSpinner(show, message = '') {
    if (!this.hasSpinnerTarget || !this.hasStatusTarget) return

    if (show) {
      this.spinnerTarget.textContent = 'Loading lessons...'
      this.spinnerTarget.classList.remove('dn')
    } else {
      this.spinnerTarget.textContent = ''
      this.spinnerTarget.classList.add('dn')
    }

    this.statusTarget.textContent = message
  }
}
